import { StoreState } from '../../../redux/reducers/store.types';

export const isModalShown = (state: StoreState): boolean =>
  state.modalMessage.shown;
